import { Box, Typography, Container, Divider } from "@mui/material";
import { Helmet } from "react-helmet-async";

function PrivacyPolicy() {
  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Helmet>
        <title>Privacy Policy — Loops</title>
        <meta name="description" content="Read Loops' Privacy Policy. We're committed to protecting your personal data in accordance with Malaysia's PDPA 2010." />
        <link rel="canonical" href="https://loopsfood.com/privacy" />
      </Helmet>
      <Typography
        variant="h3"
        sx={{ fontWeight: 500, mb: 2, textAlign: "center" }}
      >
        Privacy Policy (Malaysia PDPA 2010)
      </Typography>

      <Typography
        variant="body1"
        sx={{ color: "#6b7280", mb: 6, textAlign: "center" }}
      >
        Last updated: October 7, 2025
      </Typography>

      <Divider sx={{ mb: 6 }} />

      <Box
        sx={{
          "& h4": { fontWeight: 500, mt: 4, mb: 2 },
          "& p": { mb: 2, lineHeight: 1.7 },
        }}
      >
        <Typography variant="h4">1. Overview</Typography>
        <Typography variant="body1">
          This Privacy Policy explains how Loops collects, uses, stores, and
          protects your personal data in accordance with the Personal Data
          Protection Act 2010 (PDPA) of Malaysia.
        </Typography>

        <Typography variant="h4">2. Information We Collect</Typography>
        <Typography variant="body1">
          We may collect the following types of personal data:
        </Typography>
        <Box component="ul" sx={{ pl: 4, mb: 2 }}>
          <li>
            Name, email address, and contact details (for user accounts or
            subscriptions)
          </li>
          <li>Usage data (pages visited, clicks, device type)</li>
          <li>Communication data (messages, inquiries)</li>
        </Box>
        <Typography variant="body1">
          We do not collect sensitive personal information (e.g., race,
          religion, health data) unless voluntarily provided.
        </Typography>

        <Typography variant="h4">3. How We Use Your Data</Typography>
        <Typography variant="body1">Your data may be used to:</Typography>
        <Box component="ul" sx={{ pl: 4, mb: 2 }}>
          <li>Provide and personalize the Loops platform</li>
          <li>
            Send deal alerts, updates, or marketing communications (with
            consent)
          </li>
          <li>Improve our website’s functionality and user experience</li>
          <li>Process payments for subscriptions or partnerships</li>
        </Box>

        <Typography variant="h4">4. Data Sharing</Typography>
        <Typography variant="body1">
          We do not sell or trade your personal data. We may share limited
          information with:
        </Typography>
        <Box component="ul" sx={{ pl: 4, mb: 2 }}>
          <li>Payment processors (for subscriptions)</li>
          <li>Analytics providers (for website performance)</li>
          <li>Legal authorities (only when required by law)</li>
        </Box>

        <Typography variant="h4">5. Data Retention and Security</Typography>
        <Typography variant="body1">
          We retain your data as long as necessary for operational or legal
          purposes. We apply reasonable security measures (encryption, secure
          hosting) to protect your information from unauthorized access or
          disclosure.
        </Typography>

        <Typography variant="h4">6. Your Rights</Typography>
        <Typography variant="body1">
          Under PDPA 2010, you have the right to:
        </Typography>
        <Box component="ul" sx={{ pl: 4, mb: 2 }}>
          <li>Access and correct your personal data</li>
          <li>Withdraw consent to data processing</li>
          <li>Request deletion of your account or data</li>
        </Box>
        <Typography variant="body1">
          You can exercise these rights by contacting us at
          loops.food.my@gmail.com.
        </Typography>

        <Typography variant="h4">7. Cookies</Typography>
        <Typography variant="body1">
          Loops uses cookies to improve your browsing experience and analyze
          site usage. You may disable cookies in your browser settings, but some
          features may not function properly.
        </Typography>

        <Typography variant="h4">8. Policy Updates</Typography>
        <Typography variant="body1">
          Loops reserves the right to update this Privacy Policy. Any major
          changes will be communicated on our website.
        </Typography>

        <Typography variant="h4">9. Contact Information</Typography>
        <Typography variant="body1">
          For questions about this policy, please contact:
        </Typography>
        <Box sx={{ pl: 2, mt: 2 }}>
          <Typography variant="body1">Loops Support</Typography>
          <Typography variant="body1">
            Email: loops.food.my@gmail.com
          </Typography>
          <Typography variant="body1">
            Location: Kuala Lumpur, Malaysia
          </Typography>
        </Box>
      </Box>
    </Container>
  );
}

export default PrivacyPolicy;
